<template>
  <q-dialog ref="dialog" :maximized="$q.screen.xs" transition-hide="fade" transition-show="fade" @hide="onDialogHide">
    <q-card class="q-dialog-plugin q-pa-sm column justify-between">
      <q-card-section class="column justify-center" style="flex:1">
        <div>
          <div class="text-h6 text-center q-mb-md">Network Connection Required</div>
          <div class="text-center">
            <q-icon class="q-my-md" color="dark-grey" name="wifi_off" size="150px" />
          </div>
          <div>A network connection is required to continue. Please make sure you are connected to the internet.</div>
        </div>
      </q-card-section>
      <q-card-actions class="column justify-end">
        <q-btn class="q-px-sm full-width" color="primary" label="OK" rounded @click="onOKClick" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      this.$emit('hide');
    },
    onOKClick() {
      this.$emit('ok');
      this.hide();
    },
    onCancelClick() {
      this.hide();
    },
  },
};
</script>
